module.exports = __webpack_public_path__ + "front/img/a1.026d7409.png";